import { useEffect, useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import {
  ICategoriesValidationInput,
  IChangeEvent,
  IInputTextArea,
} from "../../../interfaces/IInput";

export default (props: IInputTextArea) => {
  const { 
    placeholder,
    layer,
    required,
    summary,
    onValueChange,
    onPropertyChange,
    onPermaValues,
    onBlur,
    errorPosition,
    defaultValue, 
    disabled, 
    requerido, 
    datoRequerido,
  } = props;

  const [triggerError, setTriggerError] = useState<boolean>(false);
  const [triggerRequerido, setTriggerRequerido] = useState<boolean | undefined>(undefined);
  const [eventValidation, setEventValidation] = useState<string>("initial");
  const [value, setValue] = useState<any>('');
  const [categoriesValidation] = useState<ICategoriesValidationInput | any>({
    success: "input-success",
    error: "input-error",
    initial: "input-initial",
    caution: "input-caution",
  });

  useEffect(() => {
    if(onPropertyChange === "numeroCuenta"){
    }
  }, [defaultValue]);

  useEffect(() => {
    if (datoRequerido) {
      if (requerido) {
        setTriggerRequerido(true);
        setEventValidation("caution");
      } else {
        setTriggerRequerido(false);
        setEventValidation("success");
      }
    }
  }, [requerido, defaultValue]);

  const handleChange = (event: IChangeEvent) => {
    const { value } = event;
    setValue(value);
  };

  const calculateRows = (value: any) => {
    const rows = value.split('\n').length;
    return rows > 4 ? rows : 4; // Establece un mínimo de 4 filas
  }


  const handleChangeEventError = (event: IChangeEvent) => {
    const { value } = event;
    let trigger: boolean = false;
    let triggerRequired: boolean = false;
    let eventValidation: string = "initial";

    if (required) {
      trigger = value !== "" ? false : true;
      eventValidation = value !== "" ? "success" : "error";
    }

    if (!required) {
      eventValidation = value !== "" ? "success" : "initial";
    }

    if (datoRequerido) {
      if (requerido) {
        triggerRequired = value !== "" ? false : true;
        eventValidation = value !== "" ? "success" : "caution";
      }
    }

    setEventValidation(eventValidation);
    setTriggerError(trigger);
    setTriggerRequerido(triggerRequired); 

    if (onPermaValues && onPropertyChange && onValueChange ) {
      
      if(typeof onPropertyChange === "string"){
        const permaValues = { ...onPermaValues };
        permaValues[onPropertyChange] = {
          value: value !== "" ? value : undefined,
          valid: trigger ? false : true,
        };
        onValueChange(permaValues);
      }
      if(typeof onPropertyChange === "object"){
        const permaValues = [ ...onPermaValues ];
        const [position, key] = onPropertyChange;
        permaValues[position][key] = {
          value: value !== "" ? value : undefined,
          valid: trigger ? false : true,
        };
        onValueChange(permaValues);
      } 
     
    } 

  };

  return (
    <div className={`w-100 ${required ? "cols-required" : "cols-not-required"}`}>
      {layer && (
        <>
          <div style={{ display: "flex" }}>
            <label className="layer">
              {layer} {summary && <i>{summary}</i>}
            </label>
            {triggerError && ["up", undefined].includes(errorPosition) && (
              <span className="layer-error"> es obligatorio</span>
            )} 
            {triggerRequerido && ["up", undefined].includes(errorPosition) && (
              <span className="layer-error">
                <ErrorIcon />
                Dato Requerido
              </span>
            )}
          </div>
        </>
      )}
      <textarea
        placeholder={placeholder}
        className={`textarea-modal-candidate ${categoriesValidation[eventValidation]}`}
        required={required}
        defaultValue={defaultValue}
        style={{ height: `${calculateRows(value) * 20}px` }} 
        disabled={disabled}
        onChange={(event) => {
          handleChangeEventError({ value: event.target.value });
          handleChange({value: event.target.value});
        }}
        onBlur={(event) => {
          handleChangeEventError({ value: event.target.value });
          if (typeof onBlur == "function") {
            onBlur(event.target.value);
          }
        }}
      />
      {triggerError && errorPosition === "down" && !disabled && (
        <span className="layer-error down">Dato obligatorio</span>
      )}
      {triggerRequerido && errorPosition === "down" && !disabled && (
        <span className="layer-caution down">
          <ErrorIcon />
          Dato Requerido
        </span>
      )}
    </div>
  );
};
